module.exports = __webpack_public_path__ + "img/donante-ricardos.482ec006.jpeg";